// extracted by mini-css-extract-plugin
export default {"title":"Title-module__title--RB4XQ","link":"Title-module__link--lQ3_o"};